"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortOptions = exports.getReactSelectOptionGroups = exports.getInitialSortedPayerOptions = void 0;
var _constants = require("./constants");
var _lodash = require("lodash");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var getTopPayersWithState = function getTopPayersWithState(state) {
  if (state && _constants.TOP_PAYERS_BY_STATE[state]) {
    return _constants.GENERAL_TOP_PAYERS.concat(_constants.TOP_PAYERS_BY_STATE[state]);
  }
  return _constants.GENERAL_TOP_PAYERS;
};
var sortByTopPayer = function sortByTopPayer(_ref, topPayers) {
  var payerName = _ref.payerName;
  if ((0, _lodash.includes)(topPayers, payerName)) {
    return -1;
  }
  return 1;
};
var deletePayerIdFromLabel = function deletePayerIdFromLabel(label) {
  var parts = label.toUpperCase().split(_constants.LABEL_SEPARATOR);
  var res = parts.slice(0, parts.length - 1).join(_constants.LABEL_SEPARATOR);
  return res;
};
var getReactSelectOptionGroups = function getReactSelectOptionGroups(options, state, shouldAddPayerIdInLabel) {
  var reactSelectOptions = options.map(function (option) {
    return _objectSpread(_objectSpread({}, option), {}, {
      value: option.id,
      label: shouldAddPayerIdInLabel ? "".concat(option.payerName).concat(_constants.LABEL_SEPARATOR).concat(option.payerId, ")") : option.payerName
    });
  });
  var _partition = (0, _lodash.partition)(reactSelectOptions, function (option) {
      return (0, _lodash.includes)(getTopPayersWithState(state), option.payerName);
    }),
    _partition2 = _slicedToArray(_partition, 2),
    topOptions = _partition2[0],
    otherOptions = _partition2[1];
  return {
    options: reactSelectOptions,
    groupedOptions: [_objectSpread(_objectSpread({}, _constants.SELECT_PAYER_GROUPS_CONFIG.POPULAR), {}, {
      options: (0, _lodash.sortBy)(topOptions, ['payerName'])
    }), _objectSpread(_objectSpread({}, _constants.SELECT_PAYER_GROUPS_CONFIG.ALL), {}, {
      options: (0, _lodash.sortBy)(otherOptions, ['payerName'])
    })]
  };
};
exports.getReactSelectOptionGroups = getReactSelectOptionGroups;
var getInitialSortedPayerOptions = function getInitialSortedPayerOptions(options, state) {
  return (0, _lodash.sortBy)((0, _lodash.filter)(options, function (_ref2) {
    var cpid = _ref2.cpid;
    return !!cpid;
  }), function (payer) {
    return sortByTopPayer(payer, getTopPayersWithState(state));
  }, ['payerName']);
};
exports.getInitialSortedPayerOptions = getInitialSortedPayerOptions;
var sortOptions = function sortOptions(payerIdAddedToLabel, state) {
  return function (children, searchValue) {
    if (!searchValue) {
      return children;
    }
    return children.sort(function (a, b) {
      var compareStringA = payerIdAddedToLabel ? deletePayerIdFromLabel(a.props.children).toUpperCase() : a.props.children.toUpperCase();
      var compareStringB = payerIdAddedToLabel ? deletePayerIdFromLabel(b.props.children).toUpperCase() : b.props.children.toUpperCase();
      var upperSearchValue = searchValue.toUpperCase();
      if (compareStringA.startsWith(upperSearchValue) && !compareStringB.startsWith(upperSearchValue)) {
        return -1;
      }
      if (compareStringB.startsWith(upperSearchValue) && !compareStringA.startsWith(upperSearchValue)) {
        return 1;
      }
      return compareStringA.localeCompare(compareStringB);
    });
  };
};
exports.sortOptions = sortOptions;